import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedName from 'I18n/components/FormattedName';
import { jsx as _jsx } from "react/jsx-runtime";
const TEMPLATES_URI = 'salescontentsearch/v2/search';
const TEMPLATE_FOLDERS_URI = 'sales-templates/v1/templates/folders';
// eslint-disable-next-line no-restricted-syntax
let cache;
/**
 * Meant to be used in Unit / Integration tests only
 */
export const bustTemplatesApiCache = () => {
  cache = null;
};
const createTemplateOptions = (templatesResponse, folders) => {
  const makeOption = template => ({
    text: template.name,
    value: template.contentId,
    help: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "hubspot-prosemirror.templates.help",
      options: {
        name: /*#__PURE__*/_jsx(FormattedName, {
          givenName: template.userView.firstName,
          familyName: template.userView.lastName,
          email: template.userView.email
        })
      }
    }),
    id: template.contentId
  });
  if (!folders || folders.length === 0) {
    return templatesResponse.results.map(makeOption);
  }
  const folderMap = new Map(folders.map(f => [f.id, f.name]));
  const grouped = {};
  const ungrouped = [];
  for (const template of templatesResponse.results) {
    if (template.folderId != null && folderMap.has(template.folderId)) {
      if (!grouped[template.folderId]) {
        grouped[template.folderId] = [];
      }
      grouped[template.folderId].push(template);
    } else {
      ungrouped.push(template);
    }
  }
  const groups = folders.filter(f => {
    var _grouped$f$id;
    return ((_grouped$f$id = grouped[f.id]) === null || _grouped$f$id === void 0 ? void 0 : _grouped$f$id.length) > 0;
  }).map(f => ({
    text: f.name,
    value: f.id,
    options: grouped[f.id].map(makeOption)
  }));
  if (ungrouped.length > 0) {
    groups.push(...ungrouped.map(makeOption));
  }
  return groups;
};
const getPostBody = ({
  limit = 1000,
  offset = 0,
  query = '',
  sorts = []
} = {}) => ({
  query,
  limit,
  offset,
  sorts,
  filters: [{
    field: 'content_type',
    values: ['TEMPLATE']
  }],
  contentTypesToHydrate: ['TEMPLATE']
});
function fetchTemplateFolders(httpClient) {
  return httpClient.get(TEMPLATE_FOLDERS_URI);
}
export function fetchTemplates(httpClient, searchTerm) {
  let promise;
  if (cache && !searchTerm) {
    promise = Promise.resolve(cache);
    promise.catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
    return promise;
  }
  const foldersPromise = searchTerm ? Promise.resolve([]) : fetchTemplateFolders(httpClient).catch(() => []);
  promise = Promise.all([httpClient.post(TEMPLATES_URI, {
    data: getPostBody({
      query: searchTerm || '',
      limit: searchTerm ? 100 : 1000,
      offset: 0,
      sorts: searchTerm ? [] : [{
        field: 'updated_at',
        order: 'DESC'
      }]
    })
  }), foldersPromise]).then(([res, folders]) => {
    const templateOptions = createTemplateOptions(res, searchTerm ? undefined : folders);
    if (!searchTerm) {
      cache = templateOptions;
    }
    return templateOptions;
  }).catch(error => {
    return Promise.reject(error);
  });
  promise.catch(err => {
    setTimeout(() => {
      throw err;
    });
  });
  return promise;
}
const fetchTemplate = (templateId, httpClient, email, supplementalObjects) => {
  const uri = `/sales-templates/v2/templates/render`;
  // TSFixMe: add dependency on sales-templates-service-types-lib
  return httpClient.post(uri, {
    data: {
      templateId,
      contactEmail: email,
      supplementalObjects,
      missingTokenTransformer: 'NONE'
    }
  });
};
export const templatesApiWrapper = apiClient => ({
  fetchRenderedContent({
    id,
    contactEmail,
    supplementalObjects
  }) {
    return fetchTemplate(id, apiClient, contactEmail, supplementalObjects).then(res => ({
      htmlBody: res.html,
      metadata: {
        templateId: id,
        subject: res.subject
      }
    }));
  },
  searchTemplates({
    query
  }) {
    return fetchTemplates(apiClient, query);
  }
});